import { useEffect, useMemo } from "react";
import useTenant from "./hooks/useTenant";
import { getRdRentalSubscriptionByTenantId } from "../services/Subscription";
import Cookies from "js-cookie";

export const TenantSubscriptionBanner = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { handleTenantError, tenantInactive, subscriptionEndDate, setSubscriptionEndDate, refreshTheSubscription, setRefreshTheSubscription }: any = useTenant();

    useEffect(() => {
        if (tenantId && refreshTheSubscription) {
            setRefreshTheSubscription(false);
            getRdRentalSubscriptionByTenantId(tenantId)
                .then(res => {
                    setSubscriptionEndDate(res?.endDate);
                    handleTenantError(null);
                })
                .catch(error => {
                    console.error(error);
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenantId, refreshTheSubscription])

    // calculate days left
    const daysLeft = useMemo(() => {
        if (!subscriptionEndDate) return null;

        const today = new Date();
        const endDate = new Date(subscriptionEndDate);

        const diffTime = endDate.getTime() - today.getTime();
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }, [subscriptionEndDate]);

    if (tenantInactive) return null;

    if (daysLeft === null) return null;

    if (daysLeft > 7) return null;

    return (
        <div className="bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-3 text-center font-medium">
            {
                daysLeft !== null && daysLeft > 0
                    ? (
                        <>⚠️ Your subscription will expire in {daysLeft} day(s). Please renew soon.</>
                    ) : (
                        <>⚠️ Your subscription has expired. Please contact your support.</>
                    )
            }
        </div>
    );
};
